export default {
    user: null,
    // socialUser: null,
    // userFormValues: null,
    // selectedPlanCode: null,
    // paymentMethod: null,
};
